import { getDateTemporality } from '../utils/date';
import { Badge } from './badge';

/**
 * "Expired" (red) once the date has passed, "Expiring soon" (amber, hazard icon) within
 * the shared 30-day warning window, nothing otherwise — the same thresholds that colour
 * expiry dates (`getDateTemporalityClass`).
 */
export function ExpirationBadge({
  expiresOn,
  'data-testid': testId = 'expiration-badge',
}: {
  /** API local date (YYYY-MM-DD), ISO string or Date; nothing renders when unset. */
  expiresOn: string | Date | null | undefined;
  'data-testid'?: string;
}) {
  const temporality = getDateTemporality(expiresOn);
  if (temporality === 'critical') {
    return (
      <Badge color="red" data-testid={testId}>
        Expired
      </Badge>
    );
  }
  if (temporality === 'warning') {
    return (
      <Badge color="amber" data-testid={testId}>
        <i className="fas fa-triangle-exclamation" aria-hidden="true" />
        Expiring soon
      </Badge>
    );
  }
  return null;
}
